// components/GlobalLoadingLottie.jsx
import React from 'react';
import {
  Dialog,
  DialogContent,
  Box,
  Typography
} from '@mui/material';
import Lottie from 'lottie-react';
import { useCart } from '../context/CartContext';
import loadingAnimation from '../assets/loading-cart_2.json'; // Download from lottiefiles.com

const GlobalLoadingLottie = ({ language }) => {
  const { isAddingToCart } = useCart();

  return (
    <Dialog
      open={isAddingToCart}
      disableEscapeKeyDown
      maxWidth="xs"
      PaperProps={{
        sx: {
          backgroundColor: '#0D0D0D',
          borderRadius: '24px',
          border: '2px solid #FFD700',
          boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
        }
      }}
    >
      <DialogContent sx={{ textAlign: 'center', py: 4 }}>
        <Box sx={{ width: 150, height: 100, mx: 'auto', mb: 2 }}>
          <Lottie animationData={loadingAnimation} loop={true} />
        </Box>
        <Typography 
          variant="h6" 
          sx={{ 
            color: '#FFD700', 
            fontWeight: 700,
            mb: 1
          }}
        >
          {language === 'ar' ? 'جاري الإضافة إلى السلة' : 'Adding to Cart'}
        </Typography>
        <Typography 
          variant="body2" 
          sx={{ 
            color: '#B3B3B3',
          }}
        >
          {language === 'ar' 
            ? 'يرجى الانتظار...' 
            : 'Please wait...'}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default GlobalLoadingLottie;